// validators/date.ts
import { assertSchema, assertValidation, ValidationError } from "../errors.mjs";
import { AbstractValidator, makeValidatorFactory } from "../types.mjs";
var ISO_8601_REGEX = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|(?:(?:\+|-)\d{2}:\d{2}))?)?$/;
var DateValidator = class extends AbstractValidator {
  format;
  from;
  until;
  constructor(constraints = {}) {
    super();
    const { format, from, until } = constraints;
    if (from != void 0 && until !== void 0) {
      assertSchema(
        until.getTime() >= from.getTime(),
        `Constraint "until" (${until.toISOString()}) must not be before "from" (${from.toISOString()})`
      );
    }
    this.format = format;
    this.from = from;
    this.until = until;
  }
  validate(value) {
    const date2 = value instanceof Date ? new Date(value.getTime()) : typeof value === "string" ? new Date(value) : typeof value === "number" ? new Date(value) : void 0;
    assertValidation(!!date2, 'Value could not be converted to a "Date"');
    if (isNaN(date2.getTime())) throw new ValidationError("Invalid date");
    if (!(value instanceof Date)) {
      if (this.format === "iso") {
        assertValidation(typeof value === "string", 'ISO Date is not a "string"');
        assertValidation(ISO_8601_REGEX.test(value), "Invalid format for ISO Date");
      } else if (this.format === "timestamp") {
        assertValidation(typeof value === "number", 'Timestamp is not a "number"');
      }
    }
    if (this.from) {
      assertValidation(this.from.getTime() <= date2.getTime(), `Date is before ${this.from.toISOString()}`);
    }
    if (this.until) {
      assertValidation(this.until.getTime() >= date2.getTime(), `Date is after ${this.until.toISOString()}`);
    }
    return date2;
  }
};
function dateValidatorFactory(constraints) {
  return new DateValidator(constraints);
}
var date = makeValidatorFactory(new DateValidator(), dateValidatorFactory);
export {
  DateValidator,
  date,
  dateValidatorFactory
};
//# sourceMappingURL=date.mjs.map
